<template>
  <div>
    <selectCommdity :isSingle="true" :dialogVisible="visible" @confirmCommidity="confirmCommidity" @closeDialog="closeDialog" />
    <div class="dialog-container" v-show="specsDialog">
      <div class="dialog">
        <h2>选择规格</h2>
        <el-table :data="exampleList" border>
          <el-table-column v-for="(item, i) in headerList" :key="i" :prop="item" :label="item" align="center"></el-table-column>
          <el-table-column label="操作" :align="'center'">
            <template slot-scope="scope">
              <el-button type="text" @click="choose(scope.row)">选择</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
  import selectCommdity from "./selectCommdity.vue";

  export default {
    name: "selectCommditySpec",
    components: {
      selectCommdity,
    },
    props: {
      visible: {
        type: Boolean,
        default: false,
      },
      isSingle: {
        type: Boolean,
        default: false,
      },
      goods: [],
    },
    data() {
      return {
        commidity: {},
        specsDialog: false,
        headerList: [],
        exampleList: [],
      };
    },
    mounted() {},
    methods: {
      //商品选择
      choose(row) {
        //选择规格
        const attrs = {};
        const name = this.headerList[0];
        this.specsDialog = false;
        this.$emit("choose", { attrs: { name: row[name], ...row }, commidity: { ...this.commidity } });
      },
      closeDialog(v) {
        this.$emit("update:visible", v);
      },
      confirmCommidity(v) {
        //选择商品
        this.closeDialog(false);
        this.commidity = v;
        console.log(v);
        const exampleList = [];
        const { attrkey, specs = [] } = v;
        //
        specs.map((item) => {
          let obj = {};
          if (item.specs) {
            for (let i in item.specs) {
              obj[i] = item.specs[i];
            }
            obj.stock = item.stock;
            obj.uuid = item.uuid;
            exampleList.push(obj);
          }
        });
        this.headerList = attrkey.map((item) => item.name);
        if (exampleList && exampleList.length > 0) {
          if (exampleList.length === 1) {
            this.choose(exampleList[0]);
          } else {
            this.exampleList = exampleList;
            this.specsDialog = true;
          }
        }
      },
    },
  };
</script>
<style scoped></style>
